import React from 'react';
import PropTypes from 'prop-types';
import { BaseDialog, Button, Stack, Typography } from '@metarouter-private/mr-mui';
import {
  useBulkPlaybookUpdateModalContext,
  BULK_PLAYBOOK_UPDATE_MODALS,
} from 'ion-experimental/app/bulk-playbook-update/BulkPlaybookUpdateModalContext';

export default function ConfirmCancelModal({ onConfirm }) {
  const { activeModal, onCloseModal } = useBulkPlaybookUpdateModalContext();

  const isOpen = activeModal === BULK_PLAYBOOK_UPDATE_MODALS.CONFIRM_CANCEL;

  const handleConfirmCancel = () => {
    onCloseModal();
    onConfirm();
  };

  const handleStay = () => {
    onCloseModal();
  };

  return (
    <BaseDialog
      DialogProps={{
        open: isOpen,
        onClose: handleStay,
        fullWidth: true,
        maxWidth: 'sm',
      }}
      title="Discard Selection?"
      content={
        <Typography>
          You have pipelines selected. Are you sure you want to leave? Your selections will be lost.
        </Typography>
      }
      actions={
        <Stack direction="row" spacing={1}>
          <Button onClick={handleStay} variant="outlined">
            Stay
          </Button>
          <Button onClick={handleConfirmCancel} color="error" variant="contained">
            Discard & Leave
          </Button>
        </Stack>
      }
    />
  );
}

ConfirmCancelModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
};
